module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/FO-f5cbd6385f381efb9507383ddc8ac733.png";